import React from 'react';
import { motion } from 'framer-motion';

function AboutSection() {
  return (
    <section className="py-20 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div
          className="text-center mb-16 mt-0"
        >
          <h2 className="text-4xl font-light sm:font-semibold text-gray-900 mb-4">Blockfirst Capital</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto text-center">
            Empowering discerning investors with innovative wealth management solutions
          </p>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-12 text-left">
          <div
            data-aos="fade-right"
            data-aos-delay="200"
            className="flex-1"
          >
            <video
              src="https://res.cloudinary.com/de57uezyv/video/upload/v1765728091/7552613-hd_1920_1080_25fps_qnpu47.mp4"
              className="w-full h-96 object-cover rounded-2xl shadow-lg transition-transform duration-700 hover:scale-105"
              autoPlay
              loop
              muted
              playsInline
            />
          </div>
          
          <div
            data-aos="fade-left"
            data-aos-delay="300"
            className="flex-1"
          >
            <h3 className="text-3xl font-semibold text-gray-900 mb-6">Leading the Future of Wealth Management</h3>
            <p className="text-lg text-gray-600 leading-relaxed mb-6 text-left">
              Blockfirst Capital stands at the forefront of innovative wealth management, combining traditional expertise with cutting-edge technology to deliver exceptional results for our clients.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed mb-8 text-left">
              Our team of seasoned professionals brings decades of experience in global markets, helping clients navigate complex financial landscapes with confidence and clarity. We believe in building lasting relationships based on trust, transparency, and proven performance.
            </p>
            <motion.a
              href="/about"
              className="inline-block px-8 py-4 rounded-full bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] hover:from-[#f59e0b] hover:to-[#d97706] text-black font-medium transition-all duration-500 shadow-lg hover:shadow-amber-500/25"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Learn More
            </motion.a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSection;
